import axios from 'axios'
import {
	Message,
	// Loading
} from 'element-ui'

var instance = axios.create({
	//baseURL: 'http://ssgtest.tmocloud.com/ssg/api',
	baseURL: process.env.VUE_APP_BASEURLSERVICE,
	// baseURL: 'http://apidoc.tmocloud.com:8081/api/app/mock/31',
	//baseURL: 'http://172.16.87.208:8084/attend/api',
	//baseURL: 'http://172.16.93.75:8084/attend/api',
	//baseURL: 'http://172.16.94.172:8084/attend/api',
	//baseURL: 'http://172.16.96.229:8083/ssg/api',
	//baseURL: 'http://172.16.93.84:8084/attend/api',
	timeout: 10000,
	withCredentials: true,
	headers: {
		'accept': 'application/json',
		'X-Requested-With': 'XMLHttpRequest'
	}
});

instance.interceptors.response.use((response) => {		
	return response;
}, (error) => {	
	if (error && error.response) {		
		const status = error.response.status
		switch (status) {
			case 401:
				Message.error('登录超时，请重新登录')
				// window.location.href = error.response.data.error_uri + '/logout?callback=' + encodeURIComponent(window.location.href);
				window.location.href = process.env.VUE_APP_BASEURLSERVICEMAIN+'#/login';
				break
			case 403:
				//Message.warning('您没有操作该模块的权限，如要继续请联系管理员')
				break
		}
	}
})

export default instance
